import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import AppWithErrorBoundary from "./App";

// Make React globally available for mobile debugging
window.React = React;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppWithErrorBoundary />
);
